import { AbstractSearchCriteria } from './abstract-search-criteria';

export class AccountingRuleSearchCriteria extends AbstractSearchCriteria {
    loadOnlyNotExportedOrModified: boolean = false;
    accountingUnitCode: string = '';
    accountingEventCode: string = '';
}
